import React, { Component } from 'react'
import axios from 'axios';
import { checkAuth } from '../../utils/auth';
import { post, authformpost } from '../../utils/service'
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import { Link, withRouter } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css';
import { imageValid } from '../../utils/imageValid';
// import {UserContext} from './../../content/App'
toast.configure();
export default class Addvideo extends Component {
    constructor(props) {
        super(props)

        this.state = {
            video_name: '',
            video_file: '',
            // video_thumblane: ''
        }
        this.validator = new SimpleReactValidator();
    }
    handleChange = e => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value });
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        var formdata = new FormData(e.target);
        var formdata1 = [...formdata];
        if (this.validator.allValid()) {
            authformpost('/api/addVideo', formdata)
                .then((data) => {
                    if (data.data.success === false) {
                        toast.dark(data.data.msg,
                            { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3000 })
                    } else {
                        toast.dark(data.data.msg,
                            { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3000 })
                        this.props.history.push('/viewvideo');
                    }

                }).catch((err) => {
                    this.setState({ loading: false });
                })
        } else {
            this.validator.showMessages();
            this.forceUpdate();
            this.setState({ loading: false });
        }
    }
    render() {
        return (
            <div>
                <div className="page-header mt-0 p-3">
                    <h3 className="mb-sm-0">video Forms</h3>
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                            <Link to="/"><i className="fe fe-home"></i></Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">video Forms</li>
                    </ol>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card shadow">
                            <div className="card-header">
                                <h2 className="mb-0">video Add</h2>
                            </div>
                            <form onSubmit={this.handleSubmit}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">video Name</label>
                                                <input type="text" className="form-control" name="video_name" id="video_name" placeholder="video Name" onChange={this.handleChange} value={this.state.video_name} />
                                                {this.validator.message('video_name', this.state.video_name, 'required', { className: 'text-danger' })}
                                            </div>

                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">video link(You Tube )</label>
                                                <input type="text" className="form-control" name="video_file" id="video_file" placeholder="video link code" onChange={this.handleChange} value={this.state.video_file} />
                                                {this.validator.message('video_file', this.state.video_file, 'required', { className: 'text-danger' })}
                                            </div>

                                        </div>
                                        {/* <div className="col-md-12">
                                            <div className="form-group mb-0">
                                                <label className="form-label">Thumbnail</label>
                                                <input type="file" className="form-control" name="video_thumblane" id="video_thumblane" placeholder="Video Thumblane" onChange={this.handleChange} value={this.state.video_thumblane} />
                                                {this.validator.message('video_thumblane', this.state.video_thumblane, 'required', { className: 'text-danger' })}
                                            </div>
                                        </div> */}
                                        <div className="col-md-12">
                                            <div className="form-group m"><br>
                                            </br>
                                                <center><button className="btn btn-success">Submit</button></center>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
